module.exports = __webpack_public_path__ + "img/ic_close_primary.89bd8148.svg";